import request from './../utils/request'

export function collect(data) {
  return request({
    url: 'api/statis/collect',
    method: 'post',
    data
  })
}
